import { render, staticRenderFns } from "./bf-notice.vue?vue&type=template&id=43f6ec31&scoped=true&lang=pug&"
import script from "./bf-notice.vue?vue&type=script&lang=js&"
export * from "./bf-notice.vue?vue&type=script&lang=js&"
import style0 from "./bf-notice.vue?vue&type=style&index=0&id=43f6ec31&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f6ec31",
  null
  
)

export default component.exports